import { ReactNode, useCallback, useMemo, useState } from "react";
import { SideBarContainer } from "../../../../../../components/SideBarContainer";
import { ItemDetails } from "../components/ItemDetails";

export const useOpenSidebar = (
  type: 1 | 2,
  entryNumber: number | undefined,
  reloadData: () => void,
) => {
  const [item, setItem] = useState<string | undefined | null>(undefined);

  const close = useCallback(() => setItem(undefined), []);

  const sidebar: ReactNode = useMemo(() => {
    const title: string = item
      ? "Incident Report Details"
      : "Add Incident Report";

    return (
      <SideBarContainer
        title={title}
        setShowSideBar={close}
        customClass="sidebar__container-payoff-quote"
      >
        <ItemDetails
          id={item}
          type={type}
          entryNumber={entryNumber}
          close={close}
          reloadData={reloadData}
        />
      </SideBarContainer>
    );
  }, [close, type, item, entryNumber, reloadData]);

  return { sidebar, item, setItem };
};
